import { render, staticRenderFns } from "./daikoushenqing.vue?vue&type=template&id=3560f0e8&scoped=true"
import script from "./daikoushenqing.vue?vue&type=script&lang=js"
export * from "./daikoushenqing.vue?vue&type=script&lang=js"
import style0 from "./daikoushenqing.vue?vue&type=style&index=0&id=3560f0e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3560f0e8",
  null
  
)

export default component.exports